export default __webpack_public_path__ + "static/media/avatar_130.c83bfeb6.png";